import react, { useState, useEffect } from "react";
import { TableCell, TableRow, Box, IconButton, Modal } from "@mui/material";
import ContactsIcon from "@mui/icons-material/Contacts";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import ButtonGroup from "@mui/material/ButtonGroup";
import MinorRow from "./MinorRow";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";

import ChangeRowModal from "./ChangeRowModal";
import AddMinorModal from "./AddMinorModal";
import { addCommas } from "@persian-tools/persian-tools";

const ChangeRow = (props) => {
  //Modal styling
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 800,
    width: "90%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    mx: "auto",
  };

  //stating the previous route
  const clickHandler = () => {
    dispatch({
      type: "assign",
      payload: {
        prevRoute: "/lab/receipts/submit",
        index: 1,
      },
    });
  };

  //getting the needed data
  const { orderId, details } = props;
  const dispatch = useDispatch();

  //error handling for discountPrice and totalPrice
  const [discountError, setDiscountError] = useState(false);
  useEffect(() => {
    if (props.discountPrice === "" || isNaN(props.discountPrice)) {
      !discountError && setDiscountError(true);
    } else {
      discountError && setDiscountError(false);
    }
  }, [props.discountPrice, discountError]);
  const [totalError, setTotalError] = useState(false);
  useEffect(() => {
    if (props.totalPrice === "" || isNaN(props.totalPrice)) {
      !totalError && setTotalError(true);
    } else {
      totalError && setTotalError(false);
    }
  }, [props.totalPrice, totalError]);

  const [openRow, setOpenRow] = useState(false);
  const handleOpenRow = () => setOpenRow(true);
  const handleCloseRow = () => setOpenRow(false);
  const [openMinor, setOpenMinor] = useState(false);
  const handleOpenMinor = () => setOpenMinor(true);
  const handleCloseMinor = () => setOpenMinor(false);

  //removing minor rows
  const removeHandler = () => {
    dispatch({
      type: "deleteDetails",
      payload: {
        orderId: orderId,
      },
    });
  };

  return (
    <react.Fragment>
      <Modal open={openRow} onClose={handleCloseRow}>
        <Box sx={style}>
          <ChangeRowModal
            orderId={props.orderId}
            totalPrice={props.totalPrice}
            discountPrice={props.discountPrice}
            close={handleCloseRow}
            open={openRow}
          />
        </Box>
      </Modal>
      <Modal open={openMinor} onClose={handleCloseMinor}>
        <Box sx={style}>
          <AddMinorModal
            orderId={props.orderId}
            close={handleCloseMinor}
            open={openMinor}
          />
        </Box>
      </Modal>
      <TableRow>
        <TableCell align="justify">
          <ButtonGroup orientation="vertical" variant="text">
            <IconButton>
              <Link
                to={`/lab/orders/view/${orderId}`}
                style={{
                  color: "inherit",
                  textDecoration: "inherit",
                }}
              >
                <ContactsIcon color="inherit" onClick={clickHandler} />
              </Link>
            </IconButton>
            <IconButton>
              <EditIcon color="secondary" onClick={handleOpenRow} />
            </IconButton>
            <IconButton>
              <AddIcon color="primary" onClick={handleOpenMinor} />
            </IconButton>
            <IconButton>
              <RemoveIcon color="secondary" onClick={removeHandler} />
            </IconButton>
          </ButtonGroup>
        </TableCell>
        <TableCell align="justify">{props.doctorName}</TableCell>
        <TableCell align="justify">{props.patientName}</TableCell>
        <TableCell align="justify">{props.orderType}</TableCell>
        <TableCell align="justify">{props.unitCount}</TableCell>
        <TableCell align="justify">{addCommas(props.unitPrice)}</TableCell>
        <TableCell align="justify">{addCommas(props.totalPrice)}</TableCell>
        <TableCell align="justify">{addCommas(props.discountPrice)}</TableCell>
      </TableRow>
      {details.map((detail) => (
        <MinorRow
          key={detail.id}
          id={detail.id}
          title={detail.title}
          count={detail.count}
          totalPrice={detail.totalPrice}
          discountPrice={detail.discountPrice}
        />
      ))}
    </react.Fragment>
  );
};

export default ChangeRow;
